import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-signal-details-material',
    standalone: true,
    imports: [CommonModule, FormlyModule],
    template: `
    <div>
      <div *ngFor="let row of field.fieldGroup; let i = index" class="flex flex-row items-end gap-4 mb-4 w-full">
        <ng-container *ngFor="let f of row.fieldGroup">
          <formly-field
            [field]="f"
            [ngClass]="f.type === 'checkbox' ? 'flex-none w-auto mt-4 ml-2' : 'flex-1 min-w-[140px]'"
          ></formly-field>
        </ng-container>
        <button
          type="button"
          class="flex items-center justify-center rounded-full bg-red-100 hover:bg-red-200 text-red-500 w-8 h-8 transition"
          (click)="remove(i)"
          aria-label="Rimuovi segnale"
        >
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
      <button
        type="button"
        class="mt-2 flex items-center justify-center rounded-full border border-green-700 bg-green-500 hover:bg-green-600 text-white w-10 h-10 transition"
        (click)="add()"
        aria-label="Aggiungi segnale"
      >
        <span class="text-xl leading-none">+</span>
      </button>
    </div>
  `,
    styles: []
})
export class SignalDetailsMaterialType extends FieldType<any> {
    remove(index: number): void {
        if (this.field.fieldGroup && Array.isArray(this.field.fieldGroup)) {
            this.field.fieldGroup.splice(index, 1);
        }
    }

    add(): void {
        if (!Array.isArray(this.model)) {
            // If model is not an array, initialize it via the parent model reference
            this.formControl.setValue([]);
        }
        (this.model as any[]).push({});
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity();
    }
}
